import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon } from 'lucide-react';
export function FocusSection() {
  return <section className="py-24 bg-schwarz text-weiss relative overflow-hidden" data-id="element-44">
      {/* Subtle glow background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-royal-blue/20 blur-[100px] rounded-full pointer-events-none" data-id="element-45" />

      <div className="max-w-5xl mx-auto px-6 text-center relative z-10" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-47">
          <div className="relative shimmer-gold rounded-full p-2 mb-6" data-id="element-48">
            <AwardIcon className="w-12 h-12 text-gold" data-id="element-49" />
          </div>

          <h2 className="text-3xl md:text-4xl font-heading mb-8 text-gold" data-id="element-50">
            FOCUS Top-Mediziner Empfehlung
          </h2>

          <div className="w-24 h-px bg-gradient-to-r from-transparent via-gold to-transparent mb-10 shimmer-gold" data-id="element-51" />

          <p className="text-lg md:text-xl text-sand font-body leading-relaxed mb-8 max-w-3xl" data-id="element-52">
            Die drei Inhaber von edel & weiss:{' '}
            <strong className="text-weiss font-medium" data-id="element-53">
              Dr. Thomas Schwenk, Dr. Markus Striegel, und Dr. Johanna Herzog
              M.Sc.
            </strong>{' '}
            werden in der FOCUS-Top-Mediziner-Empfehlungsliste als führende
            Experten geführt.
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-sm md:text-base text-beige/80 font-body" data-id="element-54">
            <span className="px-4 py-2 rounded-full border border-gold/30 bg-weiss/5 shimmer-gold overflow-hidden relative" data-id="element-55">
              Ästhetische Zahnheilkunde
            </span>
            <span className="px-4 py-2 rounded-full border border-gold/30 bg-weiss/5 shimmer-gold overflow-hidden relative" data-id="element-56">
              Kieferorthopädie
            </span>
            <span className="px-4 py-2 rounded-full border border-gold/30 bg-weiss/5 shimmer-gold overflow-hidden relative" data-id="element-57">
              CMD
            </span>
            <span className="px-4 py-2 rounded-full border border-gold/30 bg-weiss/5 shimmer-gold overflow-hidden relative" data-id="element-58">
              Sportzahnmedizin
            </span>
            <span className="px-4 py-2 rounded-full border border-gold/30 bg-weiss/5 shimmer-gold overflow-hidden relative" data-id="element-59">
              Parodontologie
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}